import React from "react";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import { getTransformedId } from "@qlik/qlik/src/lib/util/format";
import Cta from "@qlik/qlik/src/components/Cta";
import { getCardBodyContent } from "@qlik/qlik/src/lib/util/helpers";
import { getColorClassName } from "@qlik/qlik/src/lib/util/colors";
import SingleCardNoBorder from "../../Card/Single-Card-No-Border";
import * as styles from "./styles.module.css";

/**
 * CardNoBorder component
 * This component renders a card with no border.
 * @param {Object} data - The data for the card.
 */
const CardNoBorder = ({ data }) => {
    const {
        title,
        subtitle,
        cardItems = [],
        additionalConfiguration,
        numberOfColumns,
        id,
        customId,
        backgroundColor,
        cta = [],
    } = data ?? {};
    const bodyContent = getCardBodyContent(data);

    // Determine the title margin based on the presence of data.title or data.subtitle
    const titleMargin = title || subtitle ? "mb-5 md:mb-15" : "";

    const shouldRenderFirstRow = title || subtitle || bodyContent;

    // Get the class name for the section padding
    const sectionSpacingClassName = getSpacingClassName(additionalConfiguration, "pt-12.5 pb-5 lg:pt-30 lg:pb-25");
    const { sectionColorMapping } = getColorClassName(backgroundColor);

    // Render the CardNoBorder component
    return (
        <section
            data-section="true"
            id={customId ?? id}
            className={`scroll-mt-45 ${styles.mobileTitle} ${sectionSpacingClassName} ${sectionColorMapping.bgColor} `}
        >
            <div className="container">
                {shouldRenderFirstRow && (
                    <div className="row">
                        <div className={`col-12 ${titleMargin}`}>
                            {data.title && <h2 className="text-center mb-5">{data.title}</h2>}
                            {data.subtitle && <p className="body-big text-center">{data.subtitle}</p>}
                            {bodyContent && <div className={`${styles.body}`}>{bodyContent}</div>}
                        </div>
                    </div>
                )}
                <div
                    className={`grid ${
                        numberOfColumns === null
                            ? "md:grid-cols-2 lg:grid-cols-4"
                            : `md:grid-cols-2 lg:grid-cols-${numberOfColumns || 3}`
                    } md:gap-x-7.5 md:gap-y-5`}
                >
                    {cardItems?.map((cardItem) => (
                        <div className="mb-5" key={cardItem.id}>
                            {/* Render SingleCardNoBorder component for each cardItem */}
                            <SingleCardNoBorder data={cardItem} />
                        </div>
                    ))}
                </div>
                {cta && cta?.length > 0 && (
                    <div className="row pt-7.5 md:pt-7.5">
                        <div className="col-12 mb-2.5">
                            {cta?.map((ct, index) => (
                                <Cta
                                    key={ct.id}
                                    data={ct}
                                    className={`block mb-7.5 mx-auto ${index === 0 ? "" : "md:text-md text-center"}`}
                                />
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
};

export default CardNoBorder;
